module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingClosepointofsale.5ef0829e.png";